// extracted by mini-css-extract-plugin
export default {"container":"MySubscription_container__DtRtO","content":"MySubscription_content__EuLZZ"};